<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text"><a href="#/xhtml/chapter001">Inventory</a></p>
<p class="toc-text"><span href="#/xhtml/chapter002" title="Link target outside of Sample">Morning</span></p>
<p class="toc-text"><span href="#/xhtml/chapter003" title="Link target outside of Sample">Noon</span></p>
<p class="toc-text"><span href="#/xhtml/chapter004" title="Link target outside of Sample">Four o’clock</span></p>
<p class="toc-text"><span href="#/xhtml/chapter005" title="Link target outside of Sample">Evening</span></p>
<p class="toc-text"><span href="#/xhtml/chapter006" title="Link target outside of Sample">Night</span></p>
<p class="toc-text"><span href="#/xhtml/gallery" title="Link target outside of Sample">A Biography of Rumer Godden</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?67a23204